'use strict';

export default function Range({titleFrom = '', valueFrom = '', titleTo = '', valueTo = '', onChangeFrom, onChangeTo}) {

    const label_length = Math.max(titleFrom.length, titleTo.length)
    const custom_padding = label_length > 2 ? 40 + (label_length-2) * 5 : null // Для англ from

    const handleChangeFrom = (value) => {
        onChangeFrom && onChangeFrom((value || '').replace(/\D/g, ""))
    }

    const handleChangeTo = (value) => {
        onChangeTo && onChangeTo((value || '').replace(/\D/g, ""))
    }

    const valueFromFormatted = (valueFrom || '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const valueToFormatted = (valueTo || '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return <React.Fragment>
        <div className="el-select__input">
            <input type="text"
                   value={valueFromFormatted}
                   style={custom_padding ? {paddingLeft: custom_padding} : {}}
                   onChange={(event) => handleChangeFrom(event.target.value)}
            />
            <label>{titleFrom}</label>
            <a role='button' className="el-select__input-clear"></a>
        </div>
        <div className="el-select__input">
            <input type="text"
                   value={valueToFormatted}
                   style={custom_padding ? {paddingLeft: custom_padding} : {}}
                   onChange={(event) => handleChangeTo(event.target.value)}
            />
            <label>{titleTo}</label>
            <a role='button' className="el-select__input-clear"></a>
        </div>
    </React.Fragment>
}